import { render, staticRenderFns } from "./main.vue?vue&type=template&id=3d25fde5&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=3d25fde5&lang=scss&scoped=true&"
import style1 from "./main.vue?vue&type=style&index=1&id=3d25fde5&scoped=true&lang=css&"
import style2 from "./main.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d25fde5",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3d25fde5', component.options)
    } else {
      api.reload('3d25fde5', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=3d25fde5&scoped=true&", function () {
      api.rerender('3d25fde5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/main.vue"
export default component.exports